import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { calculateImpressions } from 'src/app/shared/utils/promote';

type Result = ModelHookResult<{
	text: string;
	display: boolean;
}>;

export function useImpressionCalculationSubHeader(): Result {
	const { amountToBaseUnits, localizeCurrency, localizeNumber, translatePlural } = useI18n();

	const {
		data: {
			currency,
			promotionCountrySettings: { amountChoices },
			promotionSettings: { bonusCpm, bonusThreshold, cpm },
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();

	const amountForImpressionCalculation = amount || amountChoices[0];

	const impressionCount = calculateImpressions(
		amountToBaseUnits(amountForImpressionCalculation, currency.code),
		cpm,
		bonusCpm,
		bonusThreshold,
	);

	const localizedImpressionCount = localizeNumber(impressionCount);
	const formattedPromotionAmount = localizeCurrency(amountForImpressionCalculation, currency.code);

	const text = translatePlural('corgi.co.promote.impression_calculation', impressionCount, {
		impressionCount: localizedImpressionCount,
		formattedPromotionAmount,
	});

	return {
		data: {
			display: !useDonationLanguage,
			text,
		},
	};
}
